import { Lookup } from '../../../shared/model/lookup';

export class CodPaymentType extends Lookup {
  constructor(code: string, name: string) {
    super(code, name);
  }
}
